module.exports = __webpack_public_path__ + "static/media/slot-banner.ca4a183c.webp";